import { Injectable, Injector } from '@angular/core';
import { WorkAreaService } from '../../../work-area/work-area.service';
import { ReviewAppStateService, ReviewState } from './review-app-state-service';
import { ReviewService } from './review.service';

@Injectable({
  providedIn: 'root',
})
export class ReviewAppStateServiceFactory {
  private activeAppStateServices = new Map<number, ReviewAppStateService>();

  constructor(
    private reviewService: ReviewService,
    private workAreaService: WorkAreaService,
    private injector: Injector
  ) {}

  async createAppStateService(jobId: number): Promise<ReviewAppStateService> {
    if (this.activeAppStateServices.has(jobId)) {
      return this.activeAppStateServices.get(jobId)!;
    }

    const state = await this.createState(jobId);

    await state.initialize();
    this.activeAppStateServices.set(jobId, state);
    return state;
  }

  async createState(jobId: number): Promise<ReviewAppStateService> {
    const state = new ReviewAppStateService(
      jobId,
      this.reviewService,
      this.workAreaService,
      this.injector
    );

    return state;
  }

  clearState(jobId: number): void {
    const state = this.activeAppStateServices.get(jobId);
    if (state) {
      this.activeAppStateServices.delete(jobId);
    }
  }
}
